import React, { useEffect, useState } from 'react';
import { Dropdown, Menu, Button } from 'antd';
import {
  LogoutOutlined,
  UserOutlined,
  QuestionCircleOutlined,
  ContactsOutlined
} from '@ant-design/icons';
import { logout } from 'store/requests/auth';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  changeUserStore,
  getRegions,
  setActiveRegion,
} from 'store/requests/definitions';
import { Loading } from 'components';
import { LOCATION_TYPE } from 'helpers/constants';
import { TreeSelect } from 'antd';
import { connect } from 'react-redux';
import userActions from '../../../store/actions/definitions';
import { getZones } from '../../../store/requests/courier';
import { PAGE_URLS } from '../../../helpers/endpoints';
import { useHistory } from 'react-router-dom';

const Account = ({ setUserStores, setUserRegions }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const userIntrospect = useSelector((state) => state.auth.userIntrospect);
  const activeStoreId = useSelector(
    (state) => state.auth?.user?.activeStore?.id,
  );
  const activeRegionId = useSelector(
    (state) => state.auth?.user?.activeRegion?.id,
  );
  const [loading, setLoading] = useState(false);
  const [activeStoreOrRegion, setActiveStoreOrRegion] = useState();
  const [storesAndRegionsOfUser, setStoresAndRegionsOfUser] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);

  const userInfoArray = [];
  let stores = [];
  const usersStores = [];
  const allStores = [];

  useEffect(() => {
    setLoading(true);

    if (user?.activeStore) {
      const activeStore = {
        title: user?.activeStore?.name,
        id: user?.activeStore?.id,
        value: `S-${user?.activeStore?.id}`,
        type: LOCATION_TYPE.STORE,
        channel: user?.activeStore?.channel
      };
      setActiveStoreOrRegion(activeStore);
    } else {
      const activeRegion = {
        title: user?.activeRegion?.name,
        value: `R-${user?.activeRegion?.id}`,
        type: LOCATION_TYPE.REGION,
      };
      setActiveStoreOrRegion(activeRegion);
    }

    if (userIntrospect.countryId) {
      getAllRegions();
    } else {
      getUserRegionsAndStores();
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    const queryFilter = activeStoreId
      ? `store.id==${activeStoreId}`
      : `store.region.id==${activeRegionId}`;
    getZones({ queryString: `filter=${queryFilter}` });
  }, [activeStoreId, activeRegionId]);

  useEffect(() => {
    if (selectedStore) {
      changeUserActiveStoreAndRegion(selectedStore);
    }
  }, [selectedStore]);

  const getUserRegionsAndStores = () => {
    user?.roles?.forEach((role) => {
      if (role.role === 'REGIONAL_DIRECTOR' && role.directorate) {
        role.directorate?.regions?.forEach((region) => {
          region?.stores?.forEach((store) => {
            const newStore = {
              id: store.id,
              title: `${store.code} - ${store.name}`,
              value: `S-${store.id}`,
              type: LOCATION_TYPE.STORE,
              parentId: region.id,
              code: store.code,
              channel: store.channel
            };
            stores.push(newStore);
            allStores.push(store);
          });
          
          const newRegion = {
            id: region?.id,
            title: region?.name,
            name: region?.name,
            value: `R-${region?.id}`,
            children: stores,
            type: LOCATION_TYPE.REGION,
          };
          userInfoArray.push(newRegion);
          stores = [];
        });
      } 
      else if (role && role.region) {
        role.region?.stores?.forEach((store) => {
          const newStore = {
            id: store.id,
            title: `${store.code} - ${store.name}`,
            value: `S-${store.id}`,
            type: LOCATION_TYPE.STORE,
            parentId: role.region.id,
            code: store.code,
            channel: store.channel
          };
          stores.push(newStore);
          allStores.push(store);
        });
        const newRegion = {
          id: role.region?.id,
          title: role.region?.name,
          name: role.region?.name,
          value: `R-${role.region?.id}`,
          children: stores,
          type: LOCATION_TYPE.REGION,
        };
        userInfoArray.push(newRegion);
        stores = [];
      } else {
        if (role.store) {
          usersStores.push({
            value: `S-${role.store.id}`,
            title: role.store.name,
            type: LOCATION_TYPE.STORE,
            channel: role.store.channel
          });
          allStores.push(role.store);
        }
      }
    });

    usersStores.length > 0 && userInfoArray.push(...usersStores);
    setUserStores(allStores);
    setUserRegions(userInfoArray.filter((element) => element.type === LOCATION_TYPE.REGION));
    setStoresAndRegionsOfUser(userInfoArray);
  };

  const getAllRegions = async () => {
    let haveRegion = false;
    getRegions('filter=active==true&size=20000')
      .then((region) => {
        const { _embedded, page } = region;
        const { regionResponseDtoList } = _embedded ? _embedded : [];

        regionResponseDtoList?.forEach((region) => {
          if (!haveRegion && !activeRegionId && !activeStoreId) {

            const activeRegion = {
              id: region?.id,
              title: region?.name,
              value: `R-${region?.id}`,
              type: LOCATION_TYPE.REGION
            };

            haveRegion = true;
            setActiveStoreOrRegion(activeRegion);
            setActiveRegion(activeRegion);
          }
          region?.stores?.forEach((store) => {
            const newStore = {
              id: store.id,
              title: `${store.code} - ${store.name}`,
              value: `S-${store.id}`,
              type: LOCATION_TYPE.STORE,
              parentId: region.id,
              code: store.code,
              channel: store.channel
            };
            stores.push(newStore);
            allStores.push(store);
          });
          const newRegion = {
            id: region?.id,
            name: region?.name,
            title: region?.name,
            value: `R-${region?.id}`,
            children: stores,
            type: LOCATION_TYPE.REGION
          };
          userInfoArray.push(newRegion);
          stores = [];
        });

      setStoresAndRegionsOfUser(userInfoArray);
      setUserStores(allStores);
      setUserRegions(userInfoArray);
    });
  };

  const onChangeStoreOrRegion = (changedStore, label) => {
    let currentRegionOrStore = null;

    setActiveStoreOrRegion(changedStore);
    storesAndRegionsOfUser.forEach((item) => {
      if (item.value === changedStore) {
        currentRegionOrStore = item;
      } else {
        item.children?.forEach((child) => {
          if (child.value === changedStore) {
            currentRegionOrStore = child;
          }
        });
      }
    });
    setSelectedStore(currentRegionOrStore);
  };

  const tourOn = () => {
    localStorage.setItem('routeTour', true);
    window.location.reload();
  };

  const changeUserActiveStoreAndRegion = (selected) => {
    if (selected.type === LOCATION_TYPE.REGION) {
      const data = {
        userId: user.id,
        activeRegionId: +selected.value.split('-')[1],
        activeStoreId: null,
      };

      changeAndReload(data);
    } else if (selected.type === LOCATION_TYPE.STORE) {
      const data = {
        userId: user.id,
        activeRegionId: selected.parentId ? selected.parentId : null,
        activeStoreId: +selected.value.split('-')[1],
      };

      changeAndReload(data);
    }
  };

  const changeAndReload = async (data) => {
    const changeUserStoreResponse = await changeUserStore(data);
    if (
      changeUserStoreResponse !== null &&
      changeUserStoreResponse !== undefined
    ) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  useEffect(() => {
    // TODO: uncomment this lines when related ws service ready
    // const client = new Client({
    //   brokerURL: `${WS}/live-feed-distribution-center?token=${localStorage.getItem("token")}`,
    //   reconnectDelay: 10000,
    //   heartbeatOutgoing: 45000,
    //   heartbeatIncoming: 45000,
    // });
    //
    // client.onConnect = function (frame) {
    //   client.subscribe("/user/queue/live-feed-distribution-center", function (message) {
    //     window.location.reload();
    //   });
    // };
    //
    // client.onStompError = function (frame) {
    //   console.log("Broker reported error: " + frame.headers["message"]);
    //   console.log("Additional details: " + frame.body);
    // };
    //
    // client.onWebSocketError = function (frame) {
    //   if (frame.type === 'error' && frame.target.url.includes("token")) {
    //     console.log("token error: " + frame.body);
    //   }
    // }
    // client.activate();
  }, []);

  return (
    <>
      {loading && <Loading />}
      {!loading && user &&
        <div style={{ width: '30%' }}>
          <TreeSelect
            showSearch
            filterTreeNode={(search, item) => {
              return (
                item.title
                  .toLocaleLowerCase('tr-TR')
                  .indexOf(search.toLocaleLowerCase('tr-TR')) >= 0
              );
            }}
            style={{ width: '100%' }}
            value={activeStoreOrRegion}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={storesAndRegionsOfUser}
            placeholder="Please select"
            treeDefaultExpandAll
            onChange={(val, label) => onChangeStoreOrRegion(val, label)}
          />
        </div>
      }
      <div style={{ marginLeft: 'auto' }}>
        <Dropdown
          className="AccountDropdown"
          overlay={
            <Menu>
              <Menu.Item icon={<QuestionCircleOutlined />} onClick={tourOn}>
                {t('tour')}
              </Menu.Item>
              <Menu.Item icon={<ContactsOutlined />} onClick={() =>
                history.push(`${PAGE_URLS.SETTINGS}${PAGE_URLS.MY_PROFILE}`)}
              >
                {t('myProfile')}
              </Menu.Item>
              <Menu.Item icon={<LogoutOutlined />} onClick={logout}>
                {t('logOut')}
              </Menu.Item>
            </Menu>
          }
        >
          <Button className="AccountButton" type="link">
            <UserOutlined style={{ fontSize: '18px' }} />
            {user?.nameSurname}
          </Button>
        </Dropdown>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setUserStores: (stores) => {
    dispatch(userActions.setUserStores(stores));
  },
  setUserRegions: (regions) => {
    dispatch(userActions.setUserRegions(regions));
  },
});

export default connect(null, mapDispatchToProps)(Account);
